
import React, { PureComponent } from 'react';
import { AreaChart, Area, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Spinner } from 'react-bootstrap';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip">
                <div>{payload[0].payload.carrierName} ({label})</div>
                <div className="tooltipTitle_blue">Average Page Count : {payload[0].value} </div>
            </div>
        );
    }

    return null;
};

const CustomSpinner = () => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <MySpinner />
                    <div className="card-header blue-heading">
                    Top Average Page Count by Transportation Providers
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const RenderChart = ({ data }) => {

    const gradientOffset = () => {
        const dataMax = Math.max(...data.map((i) => i.totalPageCount));
        const dataMin = Math.min(...data.map((i) => i.totalPageCount));

        if (dataMax <= 0) {
            return 0;
        }
        if (dataMin >= 0) {
            return 1;
        }

        return dataMax / (dataMax - dataMin);
    };

    const off = gradientOffset();

    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <div className="card-header blue-heading">
                    Top Average Page Count by Transportation Providers
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                            <ResponsiveContainer>
                                <AreaChart
                                    width={500}
                                    height={400}
                                    data={data}
                                    margin={{
                                        top: 10,
                                        right: 30,
                                        left: 0,
                                        bottom: 0
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="carrierScacCode" />
                                    <YAxis />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <defs>
                                        <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset={off} stopColor="#1f79a4" stopOpacity={1} />
                                            <stop offset={off} stopColor="#eac205" stopOpacity={1} />
                                        </linearGradient>
                                    </defs>
                                    <Area
                                        type="monotone"
                                        dataKey="averagePageCount"
                                        name="Average Page Count"
                                        stroke="#1f79a4"
                                        fill="url(#splitColor)"
                                    />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

export default function TopProviderByPageCount({ data, loading }) {

    if (loading) {
        return <CustomSpinner />
    }

    return <RenderChart data={data} />
}